import { render, staticRenderFns } from "./ReceberPages.vue?vue&type=template&id=f5b32ca0&"
import script from "./ReceberPages.vue?vue&type=script&lang=js&"
export * from "./ReceberPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports